// removed by extract-text-webpack-plugin
module.exports = {"MarketConditionsLegend":"MarketConditionsLegend__MarketConditionsLegend__17e1e","table":"MarketConditionsLegend__table__w7YMB","left":"MarketConditionsLegend__left__3G9vO","right":"MarketConditionsLegend__right__2Apt8","center":"MarketConditionsLegend__center__3ERTT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MarketConditionsLegend/MarketConditionsLegend.css
// module id = 557
// module chunks = 0